import { getAlternativeTextCardReason } from '@wix/a11y-rules';
import { ElementStatus } from '@wix/rules-panel-ui';
export const getFormStatusAndStatusMessage = (t, status, value) => {
  switch (status) {
    case ElementStatus.Failed:
      const altFailedReason = getAlternativeTextCardReason(value);
      if (altFailedReason === 'HasImageExtension') {
        return {
          status: 'error',
          statusMessage: t('accessibility-wizard.rules-list.alt-image.text-in-image.input-section.warning.has-image-extension')
        };
      }
      return null;
    case ElementStatus.Warning:
      return {
        status: 'warning',
        statusMessage: t('accessibility-wizard.rules-list.alt-image.input-section.warning.failed-to-generate')
      };
    default:
      return null;
  }
};
//# sourceMappingURL=get-form-status-and-status-message.js.map